import React,{ useState } from 'react'
import './GoUp.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowUp} from '@fortawesome/free-solid-svg-icons'
const GoUp = () => {
    const [goupActive, setGoupActive] = useState(false);

    window.addEventListener('scroll',function(e){
        e.preventDefault();
        this.scrollY > 20 ? setGoupActive(true) : setGoupActive(false);
    });

    function handleGoUp(){
        window.scroll(0, 0);
    }
  return (
    <>
        <div className={`go-up-container ${goupActive ? 'active' : ' '}`} onClick={handleGoUp}>
            <FontAwesomeIcon icon={faArrowUp} size='2x' className='arrowUpIcon'/>
            <FontAwesomeIcon icon={faArrowUp} size='2x' className='arrowUpIcon'/>
        </div>
    </>
  )
}

export default GoUp;